class DitecMobileMenu
{

    /**
     * Ditec mobile menu constructor
     * @param {boolean} debug
     */
    constructor(debug=false)
    {
        this.openButton = document.getElementById('mobile-nav__burger');
        this.closeButton = document.getElementById('mobile-nav__close');
        this.menuContainer = document.getElementById('mobile-nav');
        this.openButton && this.closeButton && this.menuContainer && this.init(debug);
        return;
    }

    /**
     * Initialise the mobile menu
     * @param {boolean} debug
     */
    init(debug=false)
    {
        this.openButton.addEventListener('click', (e) => {
            e.stopPropagation();
            debug && console.log('[DitecMobileMenu]', 'toggle');
            this.menuContainer.classList.toggle('-is-open');
        });
        this.closeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            debug && console.log('[DitecMobileMenu]', 'close');
            this.menuContainer.classList.remove('-is-open');
        });
        window.addEventListener('click', () => {
            debug && console.log('[DitecMobileMenu]', 'close');
            this.menuContainer.classList.remove('-is-open');
        });
    }

}

export default DitecMobileMenu;